import { styles as componentStyles } from './view.scss';
import { styles as componentStylesToast } from './toast.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../../assets/color-helpers.scss';
import { unsafeCSS } from 'lit';

export const styles = [
  unsafeCSS(`${commonStyles}`),
  unsafeCSS(`${colorHelpersStyles}`),
  unsafeCSS(`${componentStyles},${componentStylesToast}`),
];
export const stylesToast = [
  unsafeCSS(`${commonStyles}`),
  unsafeCSS(`${colorHelpersStyles}`),
  unsafeCSS(`${componentStylesToast}`),
];
